import React from 'react';

// eslint-disable-next-line max-len
const MECINC_LOGO = '/themes/theme/mecinc/mecInc-logo.jpg';

const MecIncTheme = {
  organisationId: '9aae0ea7-27e1-447e-a17d-b180a3742a4e',
  headerLogo: {
    src: MECINC_LOGO,
    alt: 'Mec Inc Logo',
    size: 70,
  },
  darkLogo: {
    src: MECINC_LOGO,
    alt: 'Mec Inc Logo',
    size: 70,
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#000',
    borderBottom: '4px solid #000',
    height: 80,
  },
  title: 'Mec Inc.',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="150"
        src={MECINC_LOGO} alt="Mec Inc Logo"
      />
      <br /><br />
      <h3>Mec Inc.</h3>
    </div>
  ),
  shareSite: 'https://share.mecinc.gg',
};

export default MecIncTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/mecinc.js
 **/